module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-input', _vm._b({
    attrs: {
      "value": _vm.value,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly
    },
    on: {
      "input": _vm.inputHandler
    }
  }, 'el-input', _vm.$attrs, false), [_vm._t("default"), _vm._v(" "), _c('rt-portal-icon', {
    attrs: {
      "slot": "suffix",
      "color": "#CED5EF",
      "name": "rt-portal-edit",
      "size": "14"
    },
    slot: "suffix"
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b886bb76"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/rtInput.vue
// module id = 1546
// module chunks = 124